import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { mmRecordService } from '../../services/api/mmRecord.service';
import { nomService } from '../../services/api/nom.service';
import { utils } from "../../services/helpers/utils";
import { ListDialog } from "../shared/listDialog";
import { alertService } from '../../services/helpers/alert.service';


export const MMRecordDiagnostics = (props) => {

    const _newRow = { idDiagnostic: null, idFisa: props.idFisa ?? 0 }
    const rol = sessionStorage.getItem("rol");

    const [diagnosticList, setDiagnosticList] = useState([]);
    const [defaults, setDefaults] = useState([])
    const [dropdown, setDropdown] = useState([])
    const [newDiagnostic, setNewDiagnostic] = useState(_newRow);
    const [showDialog, setShowDialog] = useState(false);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [restrictedDiags, setRestrictedDiags] = useState([]);

    const [searchTerm, setSearchTerm] = useState("");
    const [virtual, setVirtual] = useState({
        skip: 0,
        take: 10,
        pageSize: 10,
        total: 0
    });

    // Aduc dropdownul si lista de diagnostice
    useEffect(() => {
        if (props && props.idFisa) {
            mmRecordService.getDiagnostics({ recordId: props.idFisa })
                .then(response => {
                    if (response) {
                        setDiagnosticList(response);
                        props.setDiagnostice(response)
                        setVirtual((prevState) => ({ ...prevState, total: response.length }));
                    }
                });

        }



    }, [props.refresh]);

    useEffect(() => {
        nomService.getDiagnostics()
            .then(response => {
                if (response) {
                    setDropdown(response);
                }
            });

    }, []);


    useEffect(() => {
        if (dropdown.length > 0) {
            let d = [];
            for (let i = 0; i < dropdown.length; i++) {
                let diagText = dropdown[i]?.text?.toLowerCase();
                if (diagText?.length > 0 && (diagText.indexOf("z00") > 0 || diagText.indexOf("z10") > 0)) {
                    d.push(dropdown[i].id);
                }
            }
            setRestrictedDiags(d);
        }
    }, [dropdown]);


    // Dupa ce le aduc , setez defaulturile
    useEffect(() => {
        if (diagnosticList.length > 0 && dropdown.length > 0) {
            let d = [];
            for (let item in diagnosticList) {
                var el = utils.findObjectById(dropdown, diagnosticList[item].idDiagnostic)
                if (el) {
                    d.push(el);
                }
                else {
                    // Pentru diagnoticele care nu sunt active le aduc din baza si le adaug in dropdown
                    if (diagnosticList[item].idDiagnostic > 0) {
                        nomService.getDiagnosticsById({ id: diagnosticList[item].idDiagnostic })
                            .then(response => {
                                if (response) {
                                    var diag = [...dropdown];
                                    diag.push(response[0]);
                                    setDropdown(diag);
                                }
                            });
                    }
                }
            }
            setDefaults(d);


        }

    }, [diagnosticList, dropdown]);

    useEffect(() => {
        // După ce am setat defaulturile, verific dacă există diagnostice care nu sunt active
        if (restrictedDiags.length > 0 && dropdown.length > 0) {
            updateHaveRestrictionDiagnostic();
        }
    }, [restrictedDiags]);


    useEffect(() => {
        updateHaveRestrictionDiagnostic();
    }, [diagnosticList]);

    /**
     * Metoda care actualizeaza lista de diagnostice din copil si din parinte si seteaza stateul de isModified = true
     * @param {any} list - lista de diagnostice
     **/
    const updateLists = (list) => {
        setDiagnosticList(list);
        if (props.setDiagnostice) {
            props.setDiagnostice(list);
        }
        if (props.setIsModified) {
            props.setIsModified(true);
        }
    }

    const handleAddDiagnostic = () => {
        const updatedDiagnosticList = [...diagnosticList, newDiagnostic];
        updateLists(updatedDiagnosticList);
        setNewDiagnostic(_newRow);
    };

    const handleDiagnosticChange = (event, index, field) => {
        const updatedDiagnosticList = [...diagnosticList];
        var v = event.target.value;

        if (!props.isApt && restrictedDiags.includes(v.id)) {
            alertService.error(`Pentru oricare aviz medical cu exceptia APT nu se poate selecta diagnosticul ${v.text}!`);
            deleteDiagnostic(index);
            setSearchTerm("");
            return;
        } 

        updatedDiagnosticList[index][field] = v.id;
        updateLists(updatedDiagnosticList);
        setSearchTerm("");

        updateHaveRestrictionDiagnostic();
    };


    // Functia care verifica daca exista diagnostice pentru care exista anumite restrictii
    const updateHaveRestrictionDiagnostic = () => {
        
        if (diagnosticList.length == 0) {
            props.setHaveRestrictionDiagnostic(false);
            return
        }

        if (diagnosticList.length > 0) {
            for (var i = 0; i < diagnosticList.length; i++) {
                if (restrictedDiags.includes(diagnosticList[i].idDiagnostic)) {
                    props.setHaveRestrictionDiagnostic(true);
                    return;
                }
            }
        }
        props.setHaveRestrictionDiagnostic(false);
    }



    // Functia care sterge un diagnostic din lista
    const deleteDiagnostic = (index) => {
        const updatedDiagnosticList = [...diagnosticList];
        updatedDiagnosticList.splice(index, 1);
        updateLists(updatedDiagnosticList);
    }

    const handleDeleteDiagnostic = (index) => {
        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi acest diagnostic?"
            , () => { deleteDiagnostic(index) }
            , () => { return; }
        );
    };

    const handleDialog = () => {
        setShowDialog(!showDialog);
    }

    const handleClick = (item) => {
        setClickedIndex(item);
        setShowDialog(true);
    }

    const handleReturn = (item) => {
        let newList = [...diagnosticList];
        newList[clickedIndex].idDiagnostic = dropdown[item].id;
        updateLists(newList);
    }

    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);
        setVirtual((prevState) => ({
            ...prevState,
            skip: 0
        }));
    };

    const filteredDiagnostics = searchTerm
        ? dropdown.filter((item) =>
            item.text.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : dropdown;

    return (
        <>
            <fieldset>
                <legend className="pt20 pb5">Diagnostice <span className="red">*</span></legend>
                <table className="tbl tbladd mt5" name="lista_diagnostice" width="100%">
                    <thead>
                        <tr>
                            <th>Diagnostic</th>
                            {props.finalizare != 1 && rol != 2 && <th width="50">Editeaza</th>}
                            {props.finalizare != 1 && rol != 2 && <th width="50">Sterge</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {diagnosticList.map((diagnostic, index) => (
                            <tr key={index}>
                                <td>
                                    <DropDownList
                                        data={filteredDiagnostics}
                                        virtual={virtual}
                                        onVirtualPageChange={(e) => {
                                            setVirtual({
                                                skip: e.page.skip,
                                                take: e.page.take
                                            });
                                        }}
                                        textField="text"
                                        dataItemKey="id"
                                        value={defaults[index]}
                                        name="idDiagnostic"
                                        className="w750"
                                        onChange={(event) =>
                                            handleDiagnosticChange(event, index, "idDiagnostic")
                                        }

                                        disabled={props.finalizare == 1 || rol == 2}
                                        filterable
                                        onFilterChange={handleFilterChange}
                                    />
                                </td>
                                {props.finalizare != 1 && rol != 2 &&
                                    <td className="center" name="diagnostic_edit" onClick={() => handleClick(index)}>
                                        <span className="icon modifica center"></span>
                                    </td>
                                }
                                {props.finalizare != 1 && rol != 2 &&
                                    <td className="center" name="diagnostic_del" onClick={() => handleDeleteDiagnostic(index)}>
                                    <span className="icon sterge center"></span>
                                    </td>
                                }
                            </tr>
                        ))}
                    </tbody>
                </table>

                {!props.finalizare && rol != 2 &&
                    (<button name="adauga_diagnostic"
                        className="btn mt10"
                        onClick={handleAddDiagnostic}
                    >Adauga diagnostic</button>)
                }
            </fieldset>

            {
                showDialog && <ListDialog title="Diagnostice"
                    data={dropdown}
                    handleDialog={handleDialog}
                    handleReturn={handleReturn} />
            }
        </>
    );
}